
<template>
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title"> Đăng Ký Đậu Xe </h4>
      </div>
      <div class="modal-body">
        <!-- full_name -->
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`vehicle.color`)}}</label>
              <select v-model="vehicle.color" class="form-control">
                <option
                    v-for="color in colors"
                    v-bind:value="color.id"
                    :key="color.id"
                >{{ $t(`common.color.${color.name}`) }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`vehicle.manufacturer`)}}</label>
              <select v-model="vehicle.manufacturer" class="form-control">
                <option
                    v-for="manufacturer in VEHICLE_MANUFACTURER_LIST"
                    v-bind:value="manufacturer.id"
                    :key="manufacturer.id"
                >{{ manufacturer.manufacturer_name }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`vehicle.brand`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('vehicle.brand')" v-model="vehicle.brand">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`vehicle.vehicle_type`)}}</label>
              <select v-model="vehicle.vehicle_type" class="form-control">
                <option
                    v-for="type in VEHICLE_TYPE_LIST"
                    v-bind:value="type.id"
                    :key="type.id"
                >{{ $t(`vehicle.${type.name}`) }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`vehicle.plate_no`)}}</label>
              <input type="text" class="form-control" :placeholder="$t('vehicle.plate_no')" v-model="vehicle.plate_no">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>{{$t(`vehicle.vehicle_owner`)}}</label>
              <select v-model="vehicle.parking.resident_relative" class="form-control">
                <option
                    v-for="user in eligible_owners"
                    v-bind:value="user.resident_relative"
                    :key="user.resident_relative"
                >{{user.name }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.cancel')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-if="!!id"
          @click="onSave"
        >{{$t('common.save')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-else
          @click="onAdd"
        >{{$t('common.add')}}</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex"
// import utils from '@/lib/utils'

export default {
  name: "RegisterVehicleInputView",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      colors: [],
      vehicle: {
        color: 1,
        manufacturer: 16,
        brand: null,
        vehicle_type: 1,
        plate_no: null,
        parking: {
          resident_relative: null
        }
      }
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.GET_VEHICLE_DETAIL({id:this.id}).then(
          function(res) {
            let vehicle_data = res.data
            this.vehicle.color = vehicle_data.color
            this.vehicle.manufacturer = vehicle_data.manufacturer
            this.vehicle.brand = vehicle_data.brand
            this.vehicle.vehicle_type = vehicle_data.vehicle_type
            this.vehicle.plate_no = vehicle_data.plate_no
            this.vehicle.parking.resident_relative = vehicle_data.parking.resident_relative
          }.bind(this)
        )
      } else {
        this.reset()
      }
    }
  },
  computed: {
    ...mapGetters([
      "VEHICLE_MANUFACTURER_LIST",
      "VEHICLE_TYPE_LIST",
      "CARDS_LIST"
    ]),
    eligible_owners: function(){
      let eligible_owners = []
      this.CARDS_LIST.forEach(card => {
        let item = {
          name: card.name,
          resident_relative: card.resident_relative
        }
        eligible_owners.push(item)
      })
      return eligible_owners
    }
  },
  methods: {
    ...mapActions([
      "GET_VEHICLE_DETAIL",
      "GET_VEHICLE_MANUFACTURER_LIST",
      "GET_VEHICLE_TYPE_LIST",
      "GET_COLOR_LIST"
    ]),
    reset: function() {
      this.vehicle.color = 1
      this.vehicle.manufacturer = 16
      this.vehicle.brand = null
      this.vehicle.vehicle_type = 1
      this.vehicle.plate_no = null
      this.vehicle.parking.resident_relative = null
    },
    onAdd: function() {
      const saveVehicle = {
        color: this.vehicle.color,
        manufacturer: this.vehicle.manufacturer,
        brand: this.vehicle.brand,
        vehicle_type: this.vehicle.vehicle_type,
        plate_no: this.vehicle.plate_no,
        parking: {
          resident_relative: this.vehicle.parking.resident_relative
        }
      }
      this.$emit("vehicle-add", saveVehicle)
    },
    onSave: function() {
      const id = this.id
      const saveVehicle = {
        color: this.vehicle.color,
        manufacturer: this.vehicle.manufacturer,
        brand: this.vehicle.brand,
        vehicle_type: this.vehicle.vehicle_type,
        plate_no: this.vehicle.plate_no,
        parking: {
          resident_relative: this.vehicle.parking.resident_relative
        }
      }
      this.$emit("vehicle-save", id, saveVehicle)
    }
  },
  mounted() {
    this.GET_VEHICLE_MANUFACTURER_LIST()
    this.GET_VEHICLE_TYPE_LIST()
    this.GET_COLOR_LIST().then(
      function(res){
        let colors_data = res.data
        let colors = []
        colors_data.forEach(color => {
          let item = {
            id: color.id,
            name: color.color_name,
            html_code: color.html_code
          }
          colors.push(item)
        })
        this.colors = colors
      }.bind(this)
    )
  },
  components: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Customer/RegisterVehicleInputView.vue